import { SuspendedViewModel } from '../../common/suspended.view-model';
import { PushSubItemViewModel } from '../../home/pushSubItem.view-model';
import { SubItemViewModel } from '../../home/subItem.view-model';
import { AbstractContractItemViewModel } from '../abstract-contract.view-model';
import { BillItemViewModel } from '../bills/bill-item.view-model';
import { KoContractViewModel } from './ko-contract.view-model';
import { MemberContractViewModel } from './memberContract.view-model';

export class ActiveContractViewModel extends AbstractContractItemViewModel {
    public brand: string;
    public delegation?: string;
    public type: string;
    public state: string;
    public role: string;
    public member: MemberContractViewModel;
    public billItem?: BillItemViewModel;
    public hasFamilyAdvantages = false;
    public familyAdvantages?: SubItemViewModel;
    public isFamilyEligible = false;
    public isVimEligible = false;
    public suspendedContract?: SuspendedViewModel;
    public koContract?: KoContractViewModel;
    public contractReco?: PushSubItemViewModel;
    public picto?: string;
    public installationCity?: string;
}
